(function () {
  'use strict';

  var SELECTORES_RELEASIT = [
    '[data-cod-releasit]',
    '._rsi-cod-form-button',
    '._rsi-buy-now-button',
    '[class*="_rsi-buy-now"]',
    '[class*="_rsi-cod-form"] button',
    'button[class*="_rsi"]',
    'a[class*="_rsi"]'
  ];

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var cs = window.getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function zonaProducto() {
    return document.querySelector('product-info[id^="MainProduct-"]') || document;
  }

  function botonReleasit() {
    var zonas = [zonaProducto(), document];
    for (var z = 0; z < zonas.length; z++) {
      for (var i = 0; i < SELECTORES_RELEASIT.length; i++) {
        var lista = zonas[z].querySelectorAll(SELECTORES_RELEASIT[i]);
        for (var j = 0; j < lista.length; j++) {
          if (!lista[j].closest('[data-cod-cta]') && visible(lista[j])) return lista[j];
        }
      }
    }
    return null;
  }

  function formularioProducto() {
    return zonaProducto().querySelector('form[id^="product-form-"]');
  }

  function track(evento, datos) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: evento };
      for (var k in datos) p[k] = datos[k];
      window.dataLayer.push(p);
    } catch (e) {}
  }

  function abrirFormulario(origen) {
    var boton = botonReleasit();
    track('cod_abrir_formulario', { origen: origen || 'cta', con_releasit: !!boton });
    if (boton) {
      boton.click();
      return true;
    }
    var form = formularioProducto();
    var nativo = form && form.querySelector('[type="submit"]');
    if (nativo && visible(nativo)) {
      nativo.click();
      return true;
    }
    var ancla = document.querySelector('[data-cod-ancla-compra]') || form;
    if (ancla) ancla.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  window.codAbrirFormulario = abrirFormulario;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cod-cta]');
    if (!t) return;
    e.preventDefault();
    abrirFormulario(t.getAttribute('data-cod-cta') || 'cta');
  });

  function formatoCOP(centavos) {
    var pesos = Math.round(Number(centavos) / 100);
    return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  window.codFormatoCOP = formatoCOP;

  function inputCantidad() {
    var zona = zonaProducto();
    return zona.querySelector('input[name="quantity"].quantity__input') || zona.querySelector('input[name="quantity"]');
  }

  function fijarCantidad(n) {
    var input = inputCantidad();
    if (!input) {
      var form = formularioProducto();
      if (!form) return;
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }
    input.value = String(n);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // PUB_SUB_EVENTS de Dawn es un `const` global: existe como identificador pero NO como window.PUB_SUB_EVENTS
  function alCambiarVariante(fn) {
    if (typeof window.subscribe !== 'function') return null;
    var nombre = 'variant-change';
    try { if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) nombre = PUB_SUB_EVENTS.variantChange; } catch (e) {}
    return window.subscribe(nombre, fn);
  }

  window.codAlCambiarVariante = alCambiarVariante;

  function precioVarianteActual() {
    var zona = zonaProducto();
    var data = zona.querySelector('[data-cod-precio-base]');
    return data ? Number(data.getAttribute('data-cod-precio-base')) : null;
  }

  if (!customElements.get('cod-packs')) {
    class CodPacks extends HTMLElement {
      connectedCallback() {
        this.base = Number(this.dataset.precio || 0);
        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
        var marcado = this.querySelector('input[type="radio"]:checked') || this.querySelector('input[type="radio"]');
        if (marcado) {
          marcado.checked = true;
          this.aplicar(marcado);
        }
        this.unsub = alCambiarVariante((function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (!v) return;
          this.base = v.price;
          this.repintar();
          // Dawn (setQuantityBoundries) deja la cantidad en el mínimo justo antes de publicar el cambio: se reaplica el pack elegido
          this.reafirmarCantidad();
        }).bind(this));
      }
      reafirmarCantidad() {
        var marcado = this.querySelector('input[type="radio"]:checked');
        var card = marcado && marcado.closest('[data-cod-pack]');
        if (!card) return;
        var u = String(Number(card.getAttribute('data-unidades')) || 1);
        var revisar = function () {
          var input = inputCantidad();
          if (!input || input.value !== u) fijarCantidad(u);
        };
        revisar();
        setTimeout(revisar, 250);
        setTimeout(revisar, 900);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        if (this.unsub) this.unsub();
      }
      onChange(e) {
        if (e.target && e.target.matches('input[type="radio"]')) this.aplicar(e.target);
      }
      total(unidades, descuento, fijo) {
        if (fijo > 0) return fijo;
        return Math.round((this.base * unidades * (100 - descuento)) / 100);
      }
      totalDe(card) {
        return this.total(Number(card.getAttribute('data-unidades')), Number(card.getAttribute('data-descuento')), Number(card.getAttribute('data-fijo') || 0));
      }
      repintar() {
        var self = this;
        this.querySelectorAll('[data-cod-pack]').forEach(function (card) {
          var u = Number(card.getAttribute('data-unidades'));
          var tot = self.totalDe(card);
          var lleno = self.base * u;
          var set = function (sel, txt) { var el = card.querySelector(sel); if (el) el.textContent = txt; };
          set('[data-cod-pack-total]', formatoCOP(tot));
          set('[data-cod-pack-unidad]', (card.getAttribute('data-texto-unidad') || '[[valor]]').replace('[[valor]]', formatoCOP(Math.floor(tot / u / 100) * 100)));
          var dias = Number(self.dataset.dias || 0);
          if (dias > 0) set('[data-cod-pack-dia]', (card.getAttribute('data-texto-dia') || '[[valor]]').replace('[[valor]]', formatoCOP(Math.floor(tot / u / dias / 100) * 100)));
          if (tot < lleno) {
            set('[data-cod-pack-lleno]', formatoCOP(lleno));
            set('[data-cod-pack-ahorro]', (card.getAttribute('data-texto-ahorro') || '').replace('[[valor]]', formatoCOP(lleno - tot)));
          }
        });
        var marcado = this.querySelector('input[type="radio"]:checked');
        if (marcado) this.aplicar(marcado);
      }
      aplicar(radio) {
        var card = radio.closest('[data-cod-pack]');
        if (!card) return;
        var u = Number(card.getAttribute('data-unidades'));
        var d = Number(card.getAttribute('data-descuento'));
        var tot = this.totalDe(card);
        fijarCantidad(u);
        this.querySelectorAll('[data-cod-pack]').forEach(function (c) { c.classList.toggle('is-activo', c === card); });
        document.querySelectorAll('[data-cod-precio-cta]').forEach(function (el) { el.textContent = formatoCOP(tot); });
        var nombre = (card.getAttribute('data-nombre') || (card.querySelector('.cod-pack__etiqueta') || {}).textContent || '').split(' (')[0].trim();
        document.querySelectorAll('[data-cod-pack-nombre]').forEach(function (el) { el.textContent = nombre || ''; });
        // Estilo «tarjetas»: el resumen de debajo es el del pack elegido (sale calculado del Liquid; los suplementos tienen una sola variante)
        var pack = card.getAttribute('data-pack');
        this.querySelectorAll('[data-cod-resumen]').forEach(function (r) { r.hidden = r.getAttribute('data-cod-resumen') !== pack; });
        document.dispatchEvent(new CustomEvent('cod:pack', { detail: { unidades: u, descuento: d, total: tot } }));
        track('cod_pack', { unidades: u, total: Math.round(tot / 100) });
        this.pintarRegalo(card);
      }
      pintarRegalo(card) {
        var caja = this.querySelector('[data-cod-packs-regalo]');
        if (!caja) return;
        var salida = caja.querySelector('[data-cod-packs-regalo-texto]') || caja;
        var u = Number(card.getAttribute('data-unidades'));
        var regalo = card.getAttribute('data-regalo') || '';
        var texto = '';
        if (regalo) {
          texto = (caja.getAttribute('data-ganado') || '[[regalo]]').replace('[[regalo]]', regalo);
        } else {
          var siguiente = null;
          this.querySelectorAll('[data-cod-pack]').forEach(function (c) {
            var cu = Number(c.getAttribute('data-unidades'));
            if (c.getAttribute('data-regalo') && cu > u && (!siguiente || cu < Number(siguiente.getAttribute('data-unidades')))) siguiente = c;
          });
          if (siguiente) {
            texto = (caja.getAttribute('data-falta') || '')
              .replace('[[unidades]]', siguiente.getAttribute('data-unidades'))
              .replace('[[regalo]]', siguiente.getAttribute('data-regalo'));
          }
        }
        salida.textContent = texto;
        caja.hidden = !texto;
        caja.classList.toggle('is-ganado', !!regalo);
        // al cargar no se anima: reiniciar la animación fuerza un recálculo de la página que nadie ve
        var primera = !this.regaloPintado;
        this.regaloPintado = true;
        if (regalo && !primera) {
          caja.classList.remove('cod-desbloqueo');
          void caja.offsetWidth;
          caja.classList.add('cod-desbloqueo');
        }
      }
    }
    customElements.define('cod-packs', CodPacks);
  }

  if (!customElements.get('cod-barra-fija')) {
    class CodBarraFija extends HTMLElement {
      connectedCallback() {
        this.barra = this.querySelector('.cod-barra-fija');
        if (!this.barra) return;
        this.fuera = false;
        this.popup = false;
        var siempre = this.getAttribute('data-cod-aparicion') !== 'al_pasar';
        var objetivo = document.querySelector('[data-cod-ancla-compra]') || formularioProducto();
        var pendiente = false;
        // ¿Está abierto el popup de Releasit? Se recalcula también al hacer scroll: en escritorio, al cerrarlo
        // solo cambia la clase del modal (no la del body) y la barra se quedaba escondida (QA 2026-10-19, L3).
        this.estadoPopup = (function () {
          var bloqueado = document.body.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden';
          var modal = document.querySelector('[class*="_rsi"][class*="modal"], [class*="_rsi"][class*="popup"], [id*="_rsi"][id*="modal"]');
          this.popup = bloqueado || (modal ? visible(modal) : false);
        }).bind(this);
        this.onScroll = (function () {
          if (pendiente) return;
          pendiente = true;
          requestAnimationFrame((function () {
            pendiente = false;
            this.estadoPopup();
            if (!objetivo) {
              this.fuera = siempre || window.scrollY > window.innerHeight * 1.2;
            } else {
              var r = objetivo.getBoundingClientRect();
              // «siempre»: visible desde la primera pantalla; se aparta solo mientras el botón de la ficha está a la vista
              this.fuera = siempre ? (r.bottom < 0 || r.top > window.innerHeight) : r.bottom < 0;
            }
            this.actualizar();
          }).bind(this));
        }).bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
        this.mo = new MutationObserver((function () {
          this.estadoPopup();
          this.actualizar();
        }).bind(this));
        this.mo.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'], childList: true });
        this.onPack = (function (e) {
          var p = this.barra.querySelector('[data-cod-barra-precio]');
          if (p && e.detail) p.textContent = formatoCOP(e.detail.total);
        }).bind(this);
        document.addEventListener('cod:pack', this.onPack);
      }
      disconnectedCallback() {
        if (this.mo) this.mo.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('cod:pack', this.onPack);
      }
      actualizar() {
        var ver = this.fuera && !this.popup;
        this.barra.classList.toggle('is-visible', ver);
        this.barra.setAttribute('aria-hidden', String(!ver));
      }
    }
    customElements.define('cod-barra-fija', CodBarraFija);
  }

  function pascua(anio) {
    var a = anio % 19, b = Math.floor(anio / 100), c = anio % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(anio, mes - 1, dia));
  }

  function sumarDias(fecha, n) {
    var d = new Date(fecha.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d;
  }

  function aLunes(fecha) {
    var dia = fecha.getUTCDay();
    return dia === 1 ? fecha : sumarDias(fecha, (8 - dia) % 7);
  }

  function clave(fecha) {
    return fecha.toISOString().slice(0, 10);
  }

  var cacheFestivos = {};
  function festivos(anio) {
    if (cacheFestivos[anio]) return cacheFestivos[anio];
    var f = function (m, d) { return new Date(Date.UTC(anio, m - 1, d)); };
    var p = pascua(anio);
    var lista = [
      f(1, 1), f(5, 1), f(7, 20), f(8, 7), f(12, 8), f(12, 25),
      aLunes(f(1, 6)), aLunes(f(3, 19)), aLunes(f(6, 29)), aLunes(f(8, 15)), aLunes(f(10, 12)), aLunes(f(11, 1)), aLunes(f(11, 11)),
      sumarDias(p, -3), sumarDias(p, -2), sumarDias(p, 43), sumarDias(p, 64), sumarDias(p, 71)
    ];
    var set = {};
    lista.forEach(function (x) { set[clave(x)] = true; });
    cacheFestivos[anio] = set;
    return set;
  }

  function esHabil(fecha) {
    if (fecha.getUTCDay() === 0) return false;
    return !festivos(fecha.getUTCFullYear())[clave(fecha)];
  }

  // Colombia está en UTC−5 todo el año (sin horario de verano desde 1993): la hora de Bogotá se calcula a mano.
  // Crear un Intl.DateTimeFormat con timeZone carga los datos de husos horarios: ~23 ms de CPU al cargar (2026-10-19).
  var DIAS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function relojBogota() { return new Date(Date.now() - 5 * 3600 * 1000); } // leer SIEMPRE con getUTC*

  function hoyBogota() {
    var b = relojBogota();
    return new Date(Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate()));
  }

  function sumarHabiles(desde, n) {
    var d = new Date(desde.getTime());
    var cuenta = 0;
    while (cuenta < n) {
      d = sumarDias(d, 1);
      if (esHabil(d)) cuenta++;
    }
    return d;
  }

  function textoFecha(fecha) {
    var dia = DIAS_ES[fecha.getUTCDay()];
    var mes = MESES_ES[fecha.getUTCMonth()];
    return dia + ' ' + fecha.getUTCDate() + ' de ' + mes;
  }

  window.codFestivos = festivos;
  window.codFechas = { hoyBogota: hoyBogota, sumarDias: sumarDias, sumarHabiles: sumarHabiles, esHabil: esHabil, textoFecha: textoFecha, relojBogota: relojBogota };

  function minutosBogota() {
    var b = relojBogota();
    return b.getUTCHours() * 60 + b.getUTCMinutes();
  }

  function fechaDespacho() {
    var hoy = hoyBogota();
    var corte = document.querySelector('cod-linea-tiempo[data-hora], cod-corte[data-hora]');
    if (!corte) return hoy;
    var sabado = corte.getAttribute('data-sabado') === 'true';
    var despacha = function (f) { return esHabil(f) && (sabado || f.getUTCDay() !== 6); };
    var limite = Number(corte.getAttribute('data-hora') || 14) * 60 + Number(corte.getAttribute('data-minuto') || 0);
    if (despacha(hoy) && minutosBogota() < limite) return hoy;
    var d = hoy;
    for (var i = 0; i < 14; i++) {
      d = sumarDias(d, 1);
      if (despacha(d)) return d;
    }
    return d;
  }

  function pintarEntregas() {
    document.querySelectorAll('[data-cod-entrega]').forEach(function (el) {
      var min = Number(el.getAttribute('data-min') || 2);
      var max = Number(el.getAttribute('data-max') || 5);
      var plantilla = el.getAttribute('data-plantilla') || 'Recíbelo entre el [[min]] y el [[max]]';
      var base = fechaDespacho();
      var a = sumarHabiles(base, min);
      var b = sumarHabiles(base, max);
      el.textContent = plantilla.replace('[[min]]', textoFecha(a)).replace('[[max]]', textoFecha(b));
    });
  }

  function iniciarMiniaturas() {
    var lista = zonaProducto().querySelector('.thumbnail-list');
    if (!lista || lista.dataset.codMini) return;
    lista.dataset.codMini = '1';
    lista.addEventListener('click', function (e) {
      var b = e.target.closest('.thumbnail');
      if (b) window.requestAnimationFrame(function () { b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); });
    });
  }

  function iniciar() {
    pintarEntregas();
    iniciarMiniaturas();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  document.addEventListener('shopify:section:load', iniciar);
})();

(function () {
  'use strict';

  var FORZAR_MOV = /[?&]cod_movimiento=1(&|$)/.test(location.search);
  try {
    if (FORZAR_MOV) localStorage.setItem('cod_movimiento', '1');
    if (/[?&]cod_movimiento=0(&|$)/.test(location.search)) localStorage.removeItem('cod_movimiento');
    FORZAR_MOV = FORZAR_MOV || localStorage.getItem('cod_movimiento') === '1';
  } catch (e) {}
  if (FORZAR_MOV) document.documentElement.classList.add('cod-movimiento-forzado');
  var MOV_REDUCIDO = !FORZAR_MOV && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var F = window.codFechas || null;

  function observar(elementos, alVer, opciones) {
    if (!elementos.length) return;
    if (!('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { alVer(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          io.unobserve(e.target);
          alVer(e.target);
        }
      });
    }, opciones || { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    elementos.forEach(function (el) { io.observe(el); });
  }

  var OBJETIVOS_REVELAR = [
    '.cod-seccion .cod-cabecera',
    '.cod-seccion .cod-tarjeta',
    '.cod-seccion .cod-media',
    '.cod-seccion .cod-lista-checks > li',
    '.cod-seccion .cod-acordeon > details',
    '.cod-seccion .cod-cifra',
    '.cod-seccion .cod-ad',
    '.cod-seccion .cod-cta'
  ].join(',');

  // Medir cada elemento al arrancar (getBoundingClientRect) obligaba a calcular la página entera dentro del script:
  // ~115 ms de CPU en el Ritual (perfil 2026-10-19). Ahora el IntersectionObserver trae la posición sin forzar nada:
  // en su primer aviso, lo que ya está en pantalla se queda tal cual (sin parpadeo) y lo de abajo se esconde para
  // aparecer al llegar.
  function iniciarRevelar() {
    if (!document.body.classList.contains('cod-efecto-revelar') || MOV_REDUCIDO || !('IntersectionObserver' in window)) return;
    var lista = Array.prototype.slice.call(document.querySelectorAll(OBJETIVOS_REVELAR)).filter(function (el) {
      return !el.hasAttribute('data-cod-revelar') && !el.__codRevelar && !el.closest('.cod-barra-fija');
    });
    if (!lista.length) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var el = e.target;
        if (!el.hasAttribute('data-cod-revelar')) {
          var r = e.boundingClientRect;
          if (r.top < window.innerHeight && r.bottom > 0) { io.unobserve(el); return; }
          var hermanos = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.setProperty('--cod-retraso', Math.min(hermanos, 4) * 80 + 'ms');
          el.setAttribute('data-cod-revelar', '');
          return;
        }
        if (e.isIntersecting && e.intersectionRatio >= 0.15) { io.unobserve(el); el.classList.add('is-visible'); }
      });
    }, { threshold: [0, 0.15] });
    lista.forEach(function (el) { el.__codRevelar = true; io.observe(el); });
  }

  function iniciarResaltar() {
    if (!document.body.classList.contains('cod-efecto-resaltar')) return;
    var titulos = Array.prototype.slice.call(document.querySelectorAll('.cod-h2, .cod-ficha-titulo__h1, .cod-resaltado')).filter(function (el) {
      return !el.classList.contains('is-resaltado');
    });
    if (MOV_REDUCIDO) { titulos.forEach(function (el) { el.classList.add('is-resaltado'); }); return; }
    observar(titulos, function (el) { el.classList.add('is-resaltado'); }, { threshold: 0.6 });
  }

  var SELECTOR_RELEASIT = '._rsi-cod-form-button, ._rsi-buy-now-button, [class*="_rsi-buy-now"], [class*="_rsi-cod-form"] button';

  function claseAnim() {
    var a = document.body.getAttribute('data-cod-boton-anim');
    return a && a !== 'ninguna' ? 'cod-anim-' + a : '';
  }

  function aplicarAnimBotones() {
    var clase = claseAnim();
    if (!clase || MOV_REDUCIDO) return false;
    var alcance = document.body.getAttribute('data-cod-boton-alcance') || 'todos';
    var lista = [];
    if (alcance === 'todos') lista = Array.prototype.slice.call(document.querySelectorAll('.cod-boton[data-cod-cta]'));
    else lista = Array.prototype.slice.call(document.querySelectorAll('.cod-barra-fija .cod-boton[data-cod-cta]'));
    var rsi = document.querySelector(SELECTOR_RELEASIT);
    if (rsi) lista.push(rsi);
    lista.forEach(function (b) {
      if (!b.classList.contains(clase)) {
        b.classList.add(clase);
        var fondo = window.getComputedStyle(b).backgroundColor;
        if (fondo) b.style.setProperty('--cod-anim-color', fondo);
      }
    });
    return !!rsi;
  }

  function iniciarAnimBotones() {
    if (!claseAnim() || MOV_REDUCIDO) return;
    if (aplicarAnimBotones()) return;
    var intentos = 0;
    var mo = new MutationObserver(function () {
      intentos++;
      if (aplicarAnimBotones() || intentos > 200) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (!customElements.get('cod-marquesina')) {
    class CodMarquesina extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('.cod-marquesina__pista');
        if (!this.pista || MOV_REDUCIDO) return;
        this.ajustar = this.ajustar.bind(this);
        requestAnimationFrame(this.ajustar);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.ajustar);
          this.ro.observe(this);
        }
        this.addEventListener('click', function () { this.classList.toggle('is-pausada'); });
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
      ajustar() {
        var grupos = this.pista.querySelectorAll('.cod-marquesina__grupo');
        if (grupos.length < 2) return;
        var ancho = this.getBoundingClientRect().width;
        var g0 = grupos[0];
        var originales = g0.getAttribute('data-n') ? Number(g0.getAttribute('data-n')) : g0.children.length;
        g0.setAttribute('data-n', originales);
        var guard = 0;
        while (g0.getBoundingClientRect().width < ancho && guard < 12) {
          for (var i = 0; i < originales; i++) {
            var c0 = g0.children[i].cloneNode(true);
            g0.appendChild(c0);
            var c1 = g0.children[i].cloneNode(true);
            c1.setAttribute('aria-hidden', 'true');
            grupos[1].appendChild(c1);
          }
          guard++;
        }
        var velocidad = Number(this.getAttribute('data-velocidad') || 40);
        var dur = Math.max(8, g0.getBoundingClientRect().width / Math.max(velocidad, 5));
        this.style.setProperty('--cod-marquesina-dur', dur.toFixed(1) + 's');
      }
    }
    customElements.define('cod-marquesina', CodMarquesina);
  }

  if (!customElements.get('cod-rotativo')) {
    class CodRotativo extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.children);
        if (this.items.length < 2) { if (this.items[0]) this.items[0].classList.add('is-activo'); return; }
        this.i = 0;
        this.items.forEach(function (el, n) { el.classList.toggle('is-activo', n === 0); if (n) el.setAttribute('aria-hidden', 'true'); });
        this.intervalo = Math.max(2000, Number(this.getAttribute('data-intervalo') || 3500));
        this.pausa = false;
        this.addEventListener('mouseenter', (function () { this.pausa = true; }).bind(this));
        this.addEventListener('mouseleave', (function () { this.pausa = false; }).bind(this));
        this.timer = setInterval(this.siguiente.bind(this), this.intervalo);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      siguiente() {
        if (this.pausa || document.hidden) return;
        var actual = this.items[this.i];
        this.i = (this.i + 1) % this.items.length;
        var prox = this.items[this.i];
        actual.classList.remove('is-activo');
        actual.setAttribute('aria-hidden', 'true');
        prox.classList.add('is-activo');
        prox.removeAttribute('aria-hidden');
      }
    }
    customElements.define('cod-rotativo', CodRotativo);
  }

  function ahoraBogota() {
    // UTC−5 fijo (ver relojBogota): sin Intl con zona horaria, que cuesta CPU al cargar
    var b = new Date(Date.now() - 5 * 3600 * 1000);
    return { h: b.getUTCHours(), m: b.getUTCMinutes(), s: b.getUTCSeconds() };
  }

  function dos(n) { return (n < 10 ? '0' : '') + n; }
  var DIAS_CORTE = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  if (!customElements.get('cod-corte')) {
    class CodCorte extends HTMLElement {
      connectedCallback() {
        this.salida = this.querySelector('[data-cod-corte-texto]');
        if (!this.salida || !F) return;
        this.pintar = this.pintar.bind(this);
        this.pintar();
        this.timer = setInterval(this.pintar, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      habilDespacho(fecha) {
        if (!F.esHabil(fecha)) return false;
        if (this.getAttribute('data-sabado') !== 'true' && fecha.getUTCDay() === 6) return false;
        return true;
      }
      siguienteDespacho(desde) {
        var d = desde;
        for (var i = 0; i < 14; i++) {
          d = F.sumarDias(d, 1);
          if (this.habilDespacho(d)) return d;
        }
        return d;
      }
      /* Siempre un reloj (Randy, 2026-10-21: «la gente no lee; el timer se entiende y da urgencia»). Cuenta hasta el
         próximo corte de despacho REAL: hoy a la hora de corte si es día hábil y no ha pasado; si no, el siguiente día
         hábil a esa hora. Así la urgencia es verdadera: pedir antes de que llegue a cero sí sale ese día. */
      pintar() {
        var hoy = F.hoyBogota();
        var corteH = Number(this.getAttribute('data-hora') || 14);
        var corteM = Number(this.getAttribute('data-minuto') || 0);
        var corteMs = (corteH * 3600 + corteM * 60) * 1000;
        var ahora = Date.now() - 5 * 3600 * 1000; // hora de Bogotá leída como UTC, como relojBogota
        var esHoy = this.habilDespacho(hoy) && ahora < hoy.getTime() + corteMs;
        var dia = esHoy ? hoy : this.siguienteDespacho(hoy);
        var restante = Math.max(0, Math.floor((dia.getTime() + corteMs - ahora) / 1000));
        var d = Math.floor(restante / 86400), h = Math.floor((restante % 86400) / 3600);
        var m = Math.floor((restante % 3600) / 60), s = restante % 60;
        var reloj = (d > 0 ? d + ' d ' : '') + dos(h) + ':' + dos(m) + ':' + dos(s);
        var plantilla, cuando = '';
        if (esHoy) {
          plantilla = this.getAttribute('data-antes') || 'Pide en [[tiempo]] y sale hoy';
        } else {
          plantilla = this.getAttribute('data-luego') || 'Pide en [[tiempo]] y sale [[dia]]';
          var manana = F.sumarDias(hoy, 1).getTime() === dia.getTime();
          cuando = manana ? 'mañana' : 'el ' + DIAS_CORTE[dia.getUTCDay()];
        }
        var html = plantilla
          .replace('[[tiempo]]', '<span class="cod-corte__reloj">' + reloj + '</span>')
          .replace('[[dia]]', cuando);
        if (this.ultimo !== html) {
          this.salida.innerHTML = html;
          this.ultimo = html;
        }
      }
    }
    customElements.define('cod-corte', CodCorte);
  }

  if (!customElements.get('cod-linea-tiempo')) {
    class CodLineaTiempo extends HTMLElement {
      connectedCallback() {
        this.salidaPide = this.querySelector('[data-timeline-pide]');
        this.salidaDespacho = this.querySelector('[data-timeline-despacho]');
        this.salidaEntrega = this.querySelector('[data-timeline-entrega]');
        this.pintar = this.pintar.bind(this);
        this.pintar();
        this.timer = setInterval(this.pintar, 30000);
      }
      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }
      habilDespacho(fecha) {
        if (!F || !F.esHabil(fecha)) return false;
        if (this.getAttribute('data-sabado') !== 'true' && fecha.getUTCDay() === 6) return false;
        return true;
      }
      siguienteDespacho(desde) {
        var d = desde;
        for (var i = 0; i < 14; i++) {
          d = F.sumarDias(d, 1);
          if (this.habilDespacho(d)) return d;
        }
        return d;
      }
      fechaCorta(fecha) {
        var meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        var dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
        return dias[fecha.getUTCDay()] + ', ' + fecha.getUTCDate() + ' ' + meses[fecha.getUTCMonth()];
      }
      rangoEntrega(desde, hasta) {
        var meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        var d1 = desde.getUTCDate();
        var m1 = meses[desde.getUTCMonth()];
        var d2 = hasta.getUTCDate();
        var m2 = meses[hasta.getUTCMonth()];
        if (m1 === m2) {
          return d1 + ' - ' + d2 + ' ' + m1;
        }
        return d1 + ' ' + m1 + ' - ' + d2 + ' ' + m2;
      }
      pintar() {
        if (!F && window.codFechas) F = window.codFechas;
        if (!F) return;
        var hoy = F.hoyBogota();
        var ahora = ahoraBogota();
        var corteH = Number(this.getAttribute('data-hora') || 15);
        var corteM = Number(this.getAttribute('data-minuto') || 0);
        var restante = (corteH * 3600 + corteM * 60) - (ahora.h * 3600 + ahora.m * 60 + ahora.s);

        var despachaHoy = this.habilDespacho(hoy) && restante > 0;
        var fDesp;
        var textoDesp;

        if (despachaHoy) {
          fDesp = hoy;
          textoDesp = 'Hoy';
        } else {
          fDesp = this.siguienteDespacho(hoy);
          textoDesp = this.fechaCorta(fDesp);
        }

        var minDias = Number(this.getAttribute('data-min') || 2);
        var maxDias = Number(this.getAttribute('data-max') || 5);
        var fMin = F.sumarHabiles(fDesp, minDias);
        var fMax = F.sumarHabiles(fDesp, maxDias);
        var textoEntr = this.rangoEntrega(fMin, fMax);

        if (this.salidaPide) this.salidaPide.textContent = 'Hoy';
        if (this.salidaDespacho) this.salidaDespacho.textContent = textoDesp;
        if (this.salidaEntrega) this.salidaEntrega.textContent = textoEntr;
      }
    }
    customElements.define('cod-linea-tiempo', CodLineaTiempo);
  }

  if (!customElements.get('cod-cuenta')) {
    class CodCuenta extends HTMLElement {
      connectedCallback() {
        var m = String(this.dataset.fin || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        if (!m) return;
        this.fin = m[4]
          ? Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] + 5, +m[5], 0)
          : Date.UTC(+m[1], +m[2] - 1, +m[3], 23 + 5, 59, 59);
        this.reloj = this.querySelector('[data-cod-cuenta-reloj]');
        this.pintar = this.pintar.bind(this);
        this.pintar();
        this.timer = setInterval(this.pintar, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      pintar() {
        var resta = Math.floor((this.fin - Date.now()) / 1000);
        if (resta <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        var d = Math.floor(resta / 86400), h = Math.floor((resta % 86400) / 3600), mi = Math.floor((resta % 3600) / 60), s = resta % 60;
        var texto = (d > 0 ? d + ' d ' : '') + dos(h) + ' h ' + dos(mi) + ' min ' + dos(s) + ' s';
        if (this.reloj && this.reloj.textContent !== texto) this.reloj.textContent = texto;
        this.hidden = false;
      }
    }
    customElements.define('cod-cuenta', CodCuenta);
  }

  function formatearNumero(n, decimales) {
    return Number(n).toLocaleString('es-CO', { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
  }

  function iniciarCifras() {
    var lista = Array.prototype.slice.call(document.querySelectorAll('[data-cod-contar]:not([data-cod-contado])'));
    lista.forEach(function (el) { el.setAttribute('data-cod-contado', ''); });
    observar(lista, function (el) {
      var fin = Number(el.getAttribute('data-cod-contar'));
      var dec = Number(el.getAttribute('data-decimales') || 0);
      var pre = el.getAttribute('data-prefijo') || '';
      var suf = el.getAttribute('data-sufijo') || '';
      if (MOV_REDUCIDO || !isFinite(fin)) { el.textContent = pre + formatearNumero(fin, dec) + suf; return; }
      var t0 = null, dur = 1600, terminado = false;
      var textoFinal = pre + formatearNumero(fin, dec) + suf;
      function paso(t) {
        if (terminado) return;
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var v = fin * (1 - Math.pow(1 - k, 3));
        el.textContent = k < 1 ? pre + formatearNumero(v, dec) + suf : textoFinal;
        if (k < 1) requestAnimationFrame(paso);
        else terminado = true;
      }
      requestAnimationFrame(paso);
      setTimeout(function () { terminado = true; el.textContent = textoFinal; }, dur + 400);
    }, { threshold: 0.5 });
  }

  function iniciarBarras() {
    var lista = Array.prototype.slice.call(document.querySelectorAll('.cod-escasez__barra[data-cod-animar]:not(.is-visible)'));
    if (MOV_REDUCIDO) { lista.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    observar(lista, function (el) { setTimeout(function () { el.classList.add('is-visible'); }, 150); }, { threshold: 0.6 });
  }

  if (!customElements.get('cod-antes-despues')) {
    class CodAntesDespues extends HTMLElement {
      connectedCallback() {
        this.caja = this.querySelector('.cod-ad');
        this.rango = this.querySelector('.cod-ad__rango');
        if (!this.caja) return;
        var inicial = Number(this.getAttribute('data-inicial') || 50);
        this.poner(inicial);
        var self = this;
        var activo = false, x0 = 0, y0 = 0, decidido = false;
        this.caja.addEventListener('pointerdown', function (e) {
          activo = true; decidido = e.pointerType === 'mouse'; x0 = e.clientX; y0 = e.clientY;
          if (decidido) { self.caja.setPointerCapture(e.pointerId); self.desdeEvento(e); }
        });
        this.caja.addEventListener('pointermove', function (e) {
          if (!activo) return;
          if (!decidido) {
            var dx = Math.abs(e.clientX - x0), dy = Math.abs(e.clientY - y0);
            if (dx < 6 && dy < 6) return;
            if (dy > dx) { activo = false; return; }
            decidido = true;
            try { self.caja.setPointerCapture(e.pointerId); } catch (err) {}
          }
          self.desdeEvento(e);
        });
        var fin = function () { activo = false; };
        this.caja.addEventListener('pointerup', fin);
        this.caja.addEventListener('pointercancel', fin);
        if (this.rango) this.rango.addEventListener('input', function () { self.poner(Number(self.rango.value)); });
        if (!MOV_REDUCIDO && this.getAttribute('data-pista') === 'true') {
          observar([this.caja], function () { self.pista(inicial); }, { threshold: 0.6 });
        }
      }
      desdeEvento(e) {
        var r = this.caja.getBoundingClientRect();
        this.poner(((e.clientX - r.left) / r.width) * 100);
      }
      poner(p) {
        p = Math.max(0, Math.min(100, p));
        this.caja.style.setProperty('--cod-ad-pos', p.toFixed(2) + '%');
        if (this.rango) this.rango.value = String(Math.round(p));
      }
      pista(base) {
        var self = this, t0 = null, dur = 1400;
        function paso(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          self.poner(base + Math.sin(k * Math.PI * 2) * 14 * (1 - k));
          if (k < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }
    }
    customElements.define('cod-antes-despues', CodAntesDespues);
  }

  if (!customElements.get('cod-videos')) {
    class CodVideos extends HTMLElement {
      connectedCallback() {
        var videos = Array.prototype.slice.call(this.querySelectorAll('video'));
        if (!videos.length) return;
        videos.forEach(function (v) { v.muted = true; v.playsInline = true; v.loop = true; v.setAttribute('playsinline', ''); });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var v = e.target;
              if (e.isIntersecting && e.intersectionRatio >= 0.15) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
              else if (!e.isIntersecting) { v.pause(); }
            });
          }, { threshold: [0, 0.15, 0.5, 1] });
          var io = this.io;
          videos.forEach(function (v) { io.observe(v); });
        }
        this.addEventListener('click', function (e) {
          var b = e.target.closest('.cod-video__sonido');
          if (!b) return;
          var v = b.closest('.cod-video').querySelector('video');
          if (!v) return;
          var activar = v.muted;
          videos.forEach(function (o) { o.muted = true; var bb = o.closest('.cod-video').querySelector('.cod-video__sonido'); if (bb) bb.setAttribute('aria-pressed', 'false'); });
          v.muted = !activar;
          b.setAttribute('aria-pressed', String(activar));
          if (activar) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    }
    customElements.define('cod-videos', CodVideos);
  }

  function popupAbierto() {
    if (document.body.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden') return true;
    var m = document.querySelector('#_rsi-cod-form-modal, ._rsi-modal-container');
    if (!m) return false;
    var r = m.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && window.getComputedStyle(m).display !== 'none';
  }

  if (!customElements.get('cod-avisos')) {
    class CodAvisos extends HTMLElement {
      connectedCallback() {
        var datos = this.querySelector('script[type="application/json"]');
        this.caja = this.querySelector('.cod-aviso');
        if (!datos || !this.caja) return;
        try { this.items = JSON.parse(datos.textContent) || []; } catch (e) { this.items = []; }
        this.items = this.items.filter(function (x) { return x && x.titulo; });
        if (!this.items.length) return;
        this.clave = 'cod-avisos-' + (this.getAttribute('data-clave') || location.pathname);
        var estado = {};
        try { estado = JSON.parse(sessionStorage.getItem(this.clave) || '{}'); } catch (e) {}
        if (estado.cerrado) return;
        this.vistos = estado.vistos || 0;
        this.max = Number(this.getAttribute('data-max') || 4);
        if (this.vistos >= this.max) return;
        this.i = this.vistos % this.items.length;
        this.inicio = Number(this.getAttribute('data-inicio') || 8) * 1000;
        this.cada = Number(this.getAttribute('data-cada') || 20) * 1000;
        this.duracion = Number(this.getAttribute('data-duracion') || 6) * 1000;
        var self = this;
        var cerrar = this.querySelector('.cod-aviso__cerrar');
        if (cerrar) cerrar.addEventListener('click', function () { self.ocultar(); self.guardar(true); clearTimeout(self.t); });
        this.t = setTimeout(function () { self.mostrar(); }, this.inicio);
      }
      disconnectedCallback() { clearTimeout(this.t); }
      guardar(cerrado) {
        try { sessionStorage.setItem(this.clave, JSON.stringify({ vistos: this.vistos, cerrado: !!cerrado })); } catch (e) {}
      }
      mostrar() {
        var self = this;
        if (document.hidden || popupAbierto()) { this.t = setTimeout(function () { self.mostrar(); }, 4000); return; }
        var it = this.items[this.i];
        var set = function (sel, txt) { var el = self.caja.querySelector(sel); if (el) el.textContent = txt || ''; };
        set('[data-cod-aviso-titulo]', it.titulo);
        set('[data-cod-aviso-texto]', it.texto);
        set('[data-cod-aviso-cuando]', it.cuando);
        var img = this.caja.querySelector('.cod-aviso__img img');
        if (img && it.img) img.src = it.img;
        this.caja.classList.add('is-visible');
        this.caja.removeAttribute('aria-hidden');
        this.vistos++;
        this.guardar(false);
        this.t = setTimeout(function () {
          self.ocultar();
          if (self.vistos >= self.max) return;
          self.i = (self.i + 1) % self.items.length;
          self.t = setTimeout(function () { self.mostrar(); }, self.cada);
        }, this.duracion);
      }
      ocultar() {
        this.caja.classList.remove('is-visible');
        this.caja.setAttribute('aria-hidden', 'true');
      }
    }
    customElements.define('cod-avisos', CodAvisos);
  }

  function iniciar() {
    iniciarRevelar();
    iniciarResaltar();
    iniciarAnimBotones();
    iniciarCifras();
    iniciarBarras();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  if (window.codAlCambiarVariante) window.codAlCambiarVariante(function () { setTimeout(iniciarBarras, 300); });
})();

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest ? e.target.closest('[data-cod-ir-resenas]') : null;
    if (!enlace) return;
    e.preventDefault();
    var destino = enlace.getAttribute('href') || '';
    var objetivo = destino.charAt(0) === '#' ? document.getElementById(destino.slice(1)) : null;
    if (objetivo && objetivo.getBoundingClientRect().height > 0) {
      objetivo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var candidatos = document.querySelectorAll('[data-cod-resenas], [data-cod-opiniones], #reviews-wrapper, #trustoo-widget-wrapper, .cod-testimonios');
    for (var i = 0; i < candidatos.length; i++) {
      if (candidatos[i].getBoundingClientRect().height > 0) {
        candidatos[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
  });
})();

(function () {
  'use strict';

  if (!window.customElements || customElements.get('cod-resenas')) return;

  var API = 'https://api.trustoo.io/api/v1/reviews/get_product_reviews';
  var SVG_ESTRELLA = '<span class="cod-icono" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg></span>';
  var SVG_CHECK = '<span class="cod-icono" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>';
  var EJEMPLOS = [
    { star: 5, commented_at: '2026-09-20 10:00:00', author: 'Ejemplo de cliente', author_country: 'CO', content: 'Así se verá una reseña real: el texto exacto que escribió el cliente, con la fecha, el tono que compró y sus fotos si las subió.', item_type: 'Negro', verification_methodology: 1, resources: [] },
    { star: 4, commented_at: '2026-09-12 10:00:00', author: 'Ejemplo de cliente', author_country: 'CO', content: 'Las reseñas de 3 y 4 estrellas también se muestran: le dan credibilidad al resto.', verification_methodology: 2, reply_content: 'Así se ve la respuesta de la tienda debajo de una reseña.', resources: [] },
    { star: 5, commented_at: '2026-08-30 10:00:00', author: 'Ejemplo', author_country: 'CO', content: 'Vista previa del editor. En la tienda solo aparecen reseñas reales guardadas en Trustoo.', resources: [] }
  ];

  function el(tag, clase, texto) {
    var e = document.createElement(tag);
    if (clase) e.className = clase;
    if (texto != null) e.textContent = texto;
    return e;
  }

  function estrellas(n) {
    var caja = el('span', 'cod-estrellas');
    caja.setAttribute('role', 'img');
    caja.setAttribute('aria-label', n + ' de 5 estrellas');
    for (var i = 0; i < 5; i++) {
      var s = el('span', 'cod-estrella');
      s.style.setProperty('--f', Math.round(Math.max(0, Math.min(1, n - i)) * 100) + '%');
      var vacia = el('span', 'cod-estrella__vacia');
      vacia.innerHTML = SVG_ESTRELLA;
      var llena = el('span', 'cod-estrella__llena');
      llena.innerHTML = SVG_ESTRELLA;
      s.appendChild(vacia);
      s.appendChild(llena);
      caja.appendChild(s);
    }
    return caja;
  }

  function fecha(v) {
    if (!v) return '';
    var d = typeof v === 'number' ? new Date(v < 1e12 ? v * 1000 : v) : new Date(String(v).replace(' ', 'T'));
    if (isNaN(d.getTime())) return String(v).slice(0, 10);
    try {
      return new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function nombre(n) {
    n = String(n || '').trim();
    if (!n) return 'Cliente';
    var p = n.split(/\s+/);
    if (p.length > 1 && p[1] && p[1].indexOf('*') < 0) return p[0] + ' ' + p[1].charAt(0).toUpperCase() + '.';
    return p[0];
  }

  var regiones = null;
  function pais(c) {
    c = String(c || '').toUpperCase();
    if (c.length !== 2) return '';
    try {
      regiones = regiones || new Intl.DisplayNames(['es'], { type: 'region' });
      return regiones.of(c) || '';
    } catch (e) {
      return '';
    }
  }

  function verificacion(r) {
    var m = Number(r.verification_methodology);
    if (m === 1 || m === 3) return 'Compra verificada';
    if (m === 2) return 'Compra verificada en otra tienda';
    return '';
  }

  function medios(r) {
    var lista = Array.isArray(r.resources) ? r.resources : [];
    return lista.filter(function (m) {
      return m && typeof m.src === 'string' && m.src.indexOf('https://') === 0;
    });
  }

  class CodResenas extends HTMLElement {
    connectedCallback() {
      if (this.listo) return;
      this.listo = true;
      this.lista = this.querySelector('[data-cod-resenas-lista]');
      this.estado = this.querySelector('[data-cod-resenas-estado]');
      this.botonMas = this.querySelector('[data-cod-resenas-mas]');
      this.orden = this.querySelector('[data-cod-orden]');
      this.visor = this.querySelector('[data-cod-resenas-visor]');
      this.galeria = this.querySelector('[data-cod-resenas-galeria]');
      this.pistaFotos = this.querySelector('[data-cod-resenas-fotos]');
      this.botonEscribir = this.querySelector('[data-cod-resenas-escribir]');
      this.filtro = '';
      this.pagina = 0;
      this.paginas = 1;
      this.porPagina = parseInt(this.dataset.porPagina, 10) || 6;
      this.fotos = [];
      this.indiceVisor = 0;
      if (this.orden) {
        this.orden.value = this.dataset.orden || 'comprehensive-descending';
        this.orden.addEventListener('change', this.reiniciar.bind(this));
      }
      this.addEventListener('click', this.alClic.bind(this));
      if (this.visor) this.visor.addEventListener('close', this.limpiarVisor.bind(this));
      this.prepararEscribir();

      if (String(this.dataset.ejemplo).toLowerCase() === 'true') {
        this.pintar(EJEMPLOS);
        return;
      }
      var self = this;
      var arrancar = function () {
        if (self.iniciado) return;
        self.iniciado = true;
        if (self.io) self.io.disconnect();
        self.reiniciar();
        if (String(self.dataset.galeria).toLowerCase() === 'true') self.cargarGaleria();
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) {
          if (e[0].isIntersecting) arrancar();
        }, { rootMargin: '900px 0px' });
        this.io.observe(this);
      } else {
        arrancar();
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    pedir(params) {
      var q = new URLSearchParams({ shop_id: this.dataset.tienda, product_id: this.dataset.producto, no_empty: '1' });
      Object.keys(params).forEach(function (k) {
        if (params[k] !== '' && params[k] != null) q.set(k, params[k]);
      });
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var reloj = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
      return fetch(API + '?' + q.toString(), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (j) {
          if (reloj) clearTimeout(reloj);
          if (!j || j.code !== 0 || !j.data) throw new Error('api');
          return j.data;
        });
    }

    parametros(pagina) {
      var p = { page: pagina, limit: this.porPagina, sort_by: this.orden ? this.orden.value : 'comprehensive-descending' };
      if (this.filtro === 'fotos') p.has_resource = 1;
      else if (this.filtro) p.rating_filter = this.filtro;
      return p;
    }

    reiniciar() {
      this.pagina = 0;
      this.paginas = 1;
      this.lista.textContent = '';
      this.cargar();
    }

    cargar() {
      if (this.cargando) return;
      this.cargando = true;
      var self = this;
      var pagina = this.pagina + 1;
      if (pagina === 1) this.esqueleto(true);
      this.botonMas.setAttribute('aria-busy', 'true');
      this.pedir(this.parametros(pagina))
        .then(function (d) {
          self.esqueleto(false);
          self.pagina = pagina;
          self.paginas = (d.page && d.page.total_page) || pagina;
          var lista = Array.isArray(d.list) ? d.list : [];
          if (pagina === 1 && !lista.length) {
            self.mostrarEstado(self.filtro ? 'Todavía no hay reseñas con este filtro.' : 'Todavía no hay reseñas escritas.');
          } else {
            self.mostrarEstado('');
          }
          self.pintar(lista);
          self.botonMas.hidden = self.pagina >= self.paginas;
        })
        .catch(function () {
          self.esqueleto(false);
          if (pagina === 1 && !self.respaldoUsado) self.usarRespaldo();
          else self.mostrarEstado('No pudimos cargar más reseñas. Intenta de nuevo.');
        })
        .then(function () {
          self.cargando = false;
          self.botonMas.removeAttribute('aria-busy');
        });
    }

    esqueleto(activo) {
      var viejos = this.lista.querySelectorAll('.cod-resena--esqueleto');
      for (var i = 0; i < viejos.length; i++) viejos[i].remove();
      if (!activo) return;
      for (var j = 0; j < 2; j++) {
        var s = el('div', 'cod-resena cod-resena--esqueleto');
        s.setAttribute('aria-hidden', 'true');
        this.lista.appendChild(s);
      }
    }

    mostrarEstado(texto) {
      this.estado.textContent = texto;
      this.estado.hidden = !texto;
    }

    pintar(lista) {
      var nuevas = [];
      lista.forEach(function (r) {
        var t = this.tarjeta(r);
        this.lista.appendChild(t);
        nuevas.push(t);
      }, this);
      nuevas.forEach(function (t) {
        var p = t.querySelector('.cod-resena__texto');
        if (p && p.scrollHeight > p.clientHeight + 4) {
          var b = el('button', 'cod-resena__leer', 'Leer más');
          b.type = 'button';
          b.setAttribute('aria-expanded', 'false');
          p.insertAdjacentElement('afterend', b);
        } else if (p) {
          p.classList.remove('is-recortado');
        }
      });
    }

    tarjeta(r) {
      var art = el('article', 'cod-resena');
      var cab = el('div', 'cod-resena__cab');
      cab.appendChild(estrellas(Number(r.star) || 0));
      var f = fecha(r.commented_at || r.created_at);
      if (f) cab.appendChild(el('span', 'cod-resena__fecha', f));
      art.appendChild(cab);
      if (r.title) art.appendChild(el('p', 'cod-resena__titulo', String(r.title)));
      if (r.content) art.appendChild(el('p', 'cod-resena__texto is-recortado', String(r.content)));
      var ms = medios(r);
      if (ms.length) {
        var caja = el('div', 'cod-resena__medios');
        ms.slice(0, 6).forEach(function (m) {
          caja.appendChild(this.miniatura(m, r));
        }, this);
        art.appendChild(caja);
      }
      if (r.item_type) {
        var v = el('p', 'cod-resena__variante');
        v.appendChild(document.createTextNode('Compró: '));
        v.appendChild(el('strong', '', String(r.item_type)));
        art.appendChild(v);
      }
      var pie = el('div', 'cod-resena__pie');
      pie.appendChild(el('span', 'cod-resena__autor', nombre(r.author)));
      if (String(this.dataset.pais).toLowerCase() === 'true') {
        var p = pais(r.author_country);
        if (p) pie.appendChild(el('span', 'cod-resena__pais', p));
      }
      var ver = verificacion(r);
      if (ver) {
        var b = el('span', 'cod-resena__insignia');
        b.innerHTML = SVG_CHECK;
        b.appendChild(el('span', '', ver));
        pie.appendChild(b);
      }
      art.appendChild(pie);
      if (r.reply_content) {
        var rep = el('div', 'cod-resena__respuesta');
        rep.appendChild(el('strong', '', 'Respuesta de ' + (this.dataset.tiendaNombre || 'la tienda')));
        rep.appendChild(el('span', '', String(r.reply_content)));
        art.appendChild(rep);
      }
      return art;
    }

    miniatura(m, r) {
      var video = Number(m.resource_type) === 2;
      var b = el('button', 'cod-resenas__foto' + (video ? ' cod-resenas__foto--video' : ''));
      b.type = 'button';
      b.setAttribute('data-cod-foto', String(this.fotos.length));
      b.setAttribute('aria-label', (video ? 'Ver video de ' : 'Ver foto de ') + nombre(r.author));
      var miniatura = typeof m.thumb_src === 'string' && m.thumb_src.indexOf('https://') === 0 ? m.thumb_src : (video ? '' : m.src);
      if (miniatura) {
        var img = el('img');
        img.src = miniatura;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        b.appendChild(img);
      }
      this.fotos.push({ m: m, r: r });
      return b;
    }

    cargarGaleria() {
      var self = this;
      this.pedir({ page: 1, limit: 20, sort_by: 'image-descending', has_resource: 1 })
        .then(function (d) {
          var lista = Array.isArray(d.list) ? d.list : [];
          var n = 0;
          lista.forEach(function (r) {
            medios(r).forEach(function (m) {
              if (n >= 15) return;
              self.pistaFotos.appendChild(self.miniatura(m, r));
              n++;
            });
          });
          if (n > 0) {
            if (self.galeria) self.galeria.hidden = false;
            var chip = self.querySelector('[data-cod-filtro="fotos"]');
            if (chip) chip.hidden = false;
          }
        })
        .catch(function () {});
    }

    alClic(e) {
      var t = e.target;
      var filtro = t.closest('[data-cod-filtro]');
      if (filtro && this.contains(filtro)) {
        if (!filtro.disabled) this.aplicarFiltro(filtro.getAttribute('data-cod-filtro'), filtro.classList.contains('cod-resenas__barra'));
        return;
      }
      if (t.closest('[data-cod-resenas-mas]')) {
        this.cargar();
        return;
      }
      var leer = t.closest('.cod-resena__leer');
      if (leer) {
        var p = leer.previousElementSibling;
        var abierto = leer.getAttribute('aria-expanded') === 'true';
        if (p) p.classList.toggle('is-recortado', abierto);
        leer.setAttribute('aria-expanded', String(!abierto));
        leer.textContent = abierto ? 'Leer más' : 'Leer menos';
        return;
      }
      var foto = t.closest('[data-cod-foto]');
      if (foto) {
        this.abrirVisor(parseInt(foto.getAttribute('data-cod-foto'), 10));
        return;
      }
      if (t.closest('[data-cod-visor-cerrar]') || t === this.visor) {
        this.cerrarVisor();
        return;
      }
      var paso = t.closest('[data-cod-visor-paso]');
      if (paso) {
        this.moverVisor(parseInt(paso.getAttribute('data-cod-visor-paso'), 10));
        return;
      }
      if (t.closest('[data-cod-resenas-escribir]')) this.escribir();
    }

    aplicarFiltro(valor, desdeBarras) {
      this.filtro = valor || '';
      var chips = this.querySelectorAll('.cod-resenas__chip');
      for (var i = 0; i < chips.length; i++) {
        var activo = chips[i].getAttribute('data-cod-filtro') === this.filtro;
        chips[i].classList.toggle('is-activo', activo);
        chips[i].setAttribute('aria-pressed', String(activo));
      }
      this.reiniciar();
      if (desdeBarras) {
        var h = this.querySelector('[data-cod-resenas-herramientas]');
        if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    abrirVisor(i) {
      if (!this.visor || !this.fotos[i]) return;
      this.indiceVisor = i;
      this.pintarVisor();
      if (typeof this.visor.showModal === 'function') {
        if (!this.visor.open) this.visor.showModal();
      } else {
        window.open(this.fotos[i].m.src, '_blank', 'noopener');
      }
    }

    pintarVisor() {
      var item = this.fotos[this.indiceVisor];
      var media = this.visor.querySelector('[data-cod-visor-media]');
      var texto = this.visor.querySelector('[data-cod-visor-texto]');
      media.textContent = '';
      texto.textContent = '';
      if (Number(item.m.resource_type) === 2) {
        var fr = el('iframe');
        fr.src = item.m.src;
        fr.title = 'Video de la reseña';
        fr.allow = 'autoplay; fullscreen';
        media.appendChild(fr);
      } else {
        var img = el('img');
        img.src = item.m.src;
        img.alt = 'Foto de la reseña de ' + nombre(item.r.author);
        media.appendChild(img);
      }
      texto.appendChild(estrellas(Number(item.r.star) || 0));
      if (item.r.content) texto.appendChild(el('p', 'cod-resena__texto', String(item.r.content)));
      texto.appendChild(el('span', 'cod-resena__autor', nombre(item.r.author)));
      var nav = this.visor.querySelector('.cod-resenas__visor-nav');
      if (nav) nav.hidden = this.fotos.length < 2;
    }

    moverVisor(paso) {
      var n = this.fotos.length;
      if (!n) return;
      this.indiceVisor = (this.indiceVisor + paso + n) % n;
      this.pintarVisor();
    }

    cerrarVisor() {
      if (this.visor && this.visor.open) this.visor.close();
    }

    limpiarVisor() {
      var media = this.visor.querySelector('[data-cod-visor-media]');
      if (media) media.textContent = '';
    }

    prepararEscribir() {
      var b = this.botonEscribir;
      if (!b) return;
      var self = this;
      var revisar = function () {
        if (document.querySelector('.tt-write-reviews') || self.dataset.whatsapp) {
          b.hidden = false;
          return true;
        }
        return false;
      };
      if (revisar()) return;
      var intentos = 0;
      var reloj = setInterval(function () {
        if (revisar() || ++intentos > 20) clearInterval(reloj);
      }, 500);
    }

    escribir() {
      var tt = document.querySelector('.tt-write-reviews');
      if (tt) {
        tt.click();
        return;
      }
      if (this.dataset.whatsapp) {
        var msg = 'Hola, quiero dejar mi reseña de ' + (this.dataset.productoTitulo || 'mi pedido') + '.';
        window.open('https://wa.me/' + this.dataset.whatsapp + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      }
    }

    usarRespaldo() {
      this.respaldoUsado = true;
      var self = this;
      var mover = function () {
        var w = document.getElementById('trustoo-widget-wrapper');
        var caja = self.querySelector('[data-cod-resenas-respaldo]');
        if (!w || !caja) return false;
        w.classList.add('cod-resenas__trustoo');
        caja.appendChild(w);
        caja.hidden = false;
        var h = self.querySelector('[data-cod-resenas-herramientas]');
        if (h) h.hidden = true;
        self.botonMas.hidden = true;
        self.mostrarEstado('');
        return true;
      };
      if (!mover()) {
        this.mostrarEstado('Cargando reseñas…');
        setTimeout(function () {
          if (!mover()) self.mostrarEstado('No pudimos cargar las reseñas en este momento.');
        }, 2500);
      }
    }
  }

  customElements.define('cod-resenas', CodResenas);

  class CodResenaDestacada extends HTMLElement {
    connectedCallback() {
      if (this.listo) return;
      this.listo = true;
      if (String(this.dataset.ejemplo).toLowerCase() === 'true') {
        this.pintar(EJEMPLOS[0]);
        return;
      }
      var self = this;
      var minimo = parseInt(this.dataset.minimo, 10) || 5;
      var q = new URLSearchParams({ shop_id: this.dataset.tienda, product_id: this.dataset.producto, page: '1', limit: '10', sort_by: 'comprehensive-descending', no_empty: '1' });
      if (minimo >= 5) q.set('rating_filter', '5');
      fetch(API + '?' + q.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('http');
          return r.json();
        })
        .then(function (j) {
          var lista = j && j.code === 0 && j.data && Array.isArray(j.data.list) ? j.data.list : [];
          var buenas = lista.filter(function (r) {
            return Number(r.star) >= minimo && String(r.content || '').trim().length >= 30;
          });
          var elegida = buenas.filter(function (r) { return medios(r).length > 0; })[0] || buenas[0];
          if (elegida) self.pintar(elegida);
        })
        .catch(function () {});
    }

    pintar(r) {
      var est = this.querySelector('[data-cod-destacada-estrellas]');
      var txt = this.querySelector('[data-cod-destacada-texto]');
      var aut = this.querySelector('[data-cod-destacada-autor]');
      var foto = this.querySelector('[data-cod-destacada-foto]');
      est.textContent = '';
      est.appendChild(estrellas(Number(r.star) || 0));
      var contenido = String(r.content || '').trim();
      txt.textContent = '«' + (contenido.length > 240 ? contenido.slice(0, 237).trim() + '…' : contenido) + '»';
      var ver = verificacion(r);
      aut.textContent = nombre(r.author) + (ver ? ' · ' + ver : '');
      var m = medios(r).filter(function (x) { return Number(x.resource_type) !== 2; })[0];
      if (m && foto) {
        var img = el('img');
        img.src = typeof m.thumb_src === 'string' && m.thumb_src.indexOf('https://') === 0 ? m.thumb_src : m.src;
        img.alt = '';
        img.loading = 'lazy';
        foto.textContent = '';
        foto.appendChild(img);
        foto.hidden = false;
        this.classList.add('tiene-foto');
      }
      this.hidden = false;
    }
  }

  customElements.define('cod-resena-destacada', CodResenaDestacada);
})();

(function () {
  'use strict';

  function prepararSaltos() {
    var navs = document.querySelectorAll('[data-cod-saltos]');
    for (var i = 0; i < navs.length; i++) {
      var visibles = 0;
      var chips = navs[i].querySelectorAll('[data-cod-salto]');
      for (var j = 0; j < chips.length; j++) {
        var destino = document.getElementById(chips[j].getAttribute('data-cod-salto'));
        var ok = !!destino && destino.getBoundingClientRect().height > 0;
        chips[j].hidden = !ok;
        if (ok) visibles++;
      }
      navs[i].hidden = visibles === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-cod-salto]') : null;
    if (!a) return;
    var destino = document.getElementById(a.getAttribute('data-cod-salto'));
    if (!destino) return;
    e.preventDefault();
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepararSaltos);
  else prepararSaltos();
  window.addEventListener('load', prepararSaltos);
  document.addEventListener('shopify:section:load', prepararSaltos);
})();

(function () {
  'use strict';

  if (!window.customElements || customElements.get('cod-whatsapp')) return;

  class CodWhatsapp extends HTMLElement {
    connectedCallback() {
      if (this.listo) return;
      this.listo = true;
      this.boton = this.querySelector('.cod-wa__boton');
      this.panel = this.querySelector('.cod-wa__panel');
      if (!this.boton || !this.panel) return;
      var self = this;
      this.boton.addEventListener('click', function () {
        self.alternar();
      });
      this.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-cod-wa-tema]') : null;
        if (t) self.abrir(t.getAttribute('data-cod-wa-tema'));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.alternar(false);
      });
      document.addEventListener('click', function (e) {
        if (!self.contains(e.target)) self.alternar(false);
      });
      // Mientras la persona baja leyendo, el botón se esconde (no tapa el texto); vuelve al detenerse o al subir.
      // 2026-10-19: el flotante tapaba reseñas, pasos y el FAQ en casi cada pantalla del celular.
      var ultimoY = window.scrollY;
      var reposo = null;
      window.addEventListener(
        'scroll',
        function () {
          var y = window.scrollY;
          if (!self.classList.contains('is-abierto')) {
            if (y > ultimoY + 4 && y > 240) self.classList.add('is-oculto');
            else if (y < ultimoY - 4) self.classList.remove('is-oculto');
          }
          ultimoY = y;
          clearTimeout(reposo);
          reposo = setTimeout(function () {
            self.classList.remove('is-oculto');
          }, 1100);
        },
        { passive: true }
      );
    }

    alternar(forzar) {
      var abrir = typeof forzar === 'boolean' ? forzar : this.panel.hidden;
      this.panel.hidden = !abrir;
      this.boton.setAttribute('aria-expanded', String(abrir));
      this.classList.toggle('is-abierto', abrir);
    }

    abrir(tema) {
      var saludo = (this.dataset.saludo || '').replace('[[producto]]', this.dataset.producto || '');
      var texto = (saludo + ' ' + (tema || '')).trim();
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cod_whatsapp', tema: tema });
      } catch (e) {}
      window.open('https://wa.me/' + this.dataset.numero + '?text=' + encodeURIComponent(texto), '_blank', 'noopener');
      this.alternar(false);
    }
  }

  customElements.define('cod-whatsapp', CodWhatsapp);
})();

(function () {
  'use strict';

  if (!window.customElements || customElements.get('cod-hotspots')) return;

  class CodHotspots extends HTMLElement {
    connectedCallback() {
      if (this.listo) return;
      this.listo = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var punto = e.target.closest('[data-cod-hot]');
        var item = e.target.closest('[data-cod-hot-item]');
        if (punto) self.activar(punto.getAttribute('data-cod-hot'), true);
        else if (item) self.activar(item.getAttribute('data-cod-hot-item'), false);
      });
      this.activar('0', false);
    }

    activar(i, desplazar) {
      var activo = null;
      this.querySelectorAll('[data-cod-hot]').forEach(function (b) {
        var on = b.getAttribute('data-cod-hot') === i;
        b.classList.toggle('is-activo', on);
        b.setAttribute('aria-pressed', String(on));
      });
      this.querySelectorAll('[data-cod-hot-item]').forEach(function (li) {
        var on = li.getAttribute('data-cod-hot-item') === i;
        li.classList.toggle('is-activo', on);
        if (on) activo = li;
      });
      if (desplazar && activo) {
        var r = activo.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) activo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  customElements.define('cod-hotspots', CodHotspots);
})();

(function () {
  'use strict';
  var TEXTOS = { 'Free': 'Gratis', 'FREE': 'GRATIS', 'Discounts': 'Descuentos', 'Discount': 'Descuento',
    'Ingrese su dirección de envío': '¿A dónde te lo enviamos?', 'Teléfono': 'Celular con WhatsApp' };
  // Releasit habla de «usted»; la página tutea [MBS-065 @19:34] y el celular sirve para confirmar por WhatsApp [IC §10]
  var MARCADORES = { 'Número de su Celular': 'Ej: 300 123 4567' };
  var MILES_COMA = /\$\s?\d{1,3}(?:,\d{3})+(?![\d.,]*\d)/g;
  var esCOP = !!(window.Shopify && Shopify.currency && Shopify.currency.active === 'COP');

  function arreglar(n) {
    var v = n.nodeValue;
    var t = v.trim();
    if (t && Object.prototype.hasOwnProperty.call(TEXTOS, t)) {
      n.nodeValue = v.replace(t, TEXTOS[t]);
      return;
    }
    if (esCOP && v.indexOf('$') >= 0 && v.indexOf(',') >= 0) {
      var nuevo = v.replace(MILES_COMA, function (m) { return m.replace(/,/g, '.'); });
      if (nuevo !== v) n.nodeValue = nuevo;
    }
  }

  function recorrer(raiz) {
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) arreglar(n);
    if (raiz.querySelectorAll) {
      raiz.querySelectorAll('input[placeholder]').forEach(function (i) {
        if (Object.prototype.hasOwnProperty.call(MARCADORES, i.placeholder)) i.placeholder = MARCADORES[i.placeholder];
      });
    }
  }

  function raizRsi(nodo) {
    var el = nodo.nodeType === 1 ? nodo : nodo.parentElement;
    return el && el.closest ? el.closest('#_rsi-cod-form-modal, [id^="_rsi-"], [class*="_rsi-"]') : null;
  }

  function revisar(registros) {
    if (!registros) {
      document.querySelectorAll('#_rsi-cod-form-modal, [id^="_rsi-"], [class*="_rsi-buy-now-button"]').forEach(recorrer);
      return;
    }
    var vistos = [];
    registros.forEach(function (r) {
      var raiz = raizRsi(r.target);
      if (raiz && vistos.indexOf(raiz) < 0) vistos.push(raiz);
      if (r.addedNodes) {
        for (var i = 0; i < r.addedNodes.length; i++) {
          var a = r.addedNodes[i];
          if (a.nodeType === 1 && (a.id === '_rsi-cod-form-modal' || (a.querySelector && a.querySelector('#_rsi-cod-form-modal')))) vistos.push(a);
        }
      }
    });
    vistos.forEach(recorrer);
  }

  revisar();
  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Botones de Releasit con la paleta de cada producto. Releasit los pinta con estilos en línea !important (el mismo
   rojo en toda la tienda), así que solo se pueden cambiar por JS. Con «Animación del botón: ninguna» se apaga su
   sacudida (estándar premium) y el principal y el flotante dicen lo mismo que los demás CTA de la página. */
(function () {
  var b = document.body;
  if (!b || !b.hasAttribute('data-cod-boton-anim')) return;
  var cs = window.getComputedStyle(document.documentElement);
  var fondo = cs.getPropertyValue('--cod-primario').trim();
  if (!fondo) return;
  var color = cs.getPropertyValue('--cod-primario-texto').trim() || '#ffffff';
  var radio = cs.getPropertyValue('--cod-radius-boton').trim();
  var texto = b.getAttribute('data-cod-cta-texto');
  var quieto = b.getAttribute('data-cod-boton-anim') !== 'sacudida';
  var esperado = null;
  /* Estilo «Etiqueta» (propuesta 2, 2026-10-20): botón plano del color del producto, rectangular, y el precio del pack
     elegido dentro. Primera línea = el mismo texto de todos los CTA de la página (Mark: todos los botones dicen lo
     mismo [MB-001.45]); segunda línea = el precio y el tachado, cada uno en su propio bloque. */
  var etiqueta = b.classList.contains('nova-etiqueta');
  /* Paleta viva (2026-10-11): degradado del propio color (de un tono más hondo al vivo, el texto blanco queda ≥ 4,5:1 en
     todo el ancho) y sombra de su color. background-color y background-image van por separado: con «background» el
     color se resetea y el MutationObserver repintaría sin parar. */
  var degradado = 'linear-gradient(90deg, color-mix(in oklab, ' + fondo + ' 86%, #000), ' + fondo + ')';
  var sombra = '0 10px 24px color-mix(in srgb, ' + fondo + ' 40%, transparent), inset 0 1px 0 rgba(255, 255, 255, 0.22)';
  if (etiqueta) {
    degradado = 'none';
    sombra = '0 8px 18px color-mix(in srgb, ' + fondo + ' 30%, transparent)';
    radio = '8px';
  }
  var textoCta = texto || 'Pídelo hoy, pagas al recibir';
  function pesos(centavos) { return '$' + Math.round(centavos / 100).toLocaleString('es-CO'); }
  function precioElegido() {
    var packs = document.querySelector('cod-packs');
    var marcado = packs && packs.querySelector('input[type="radio"]:checked');
    var card = marcado && marcado.closest('[data-cod-pack]');
    if (card) {
      var tot = card.querySelector('[data-cod-pack-total]');
      var u = Number(card.getAttribute('data-unidades')) || 1;
      var base = Number(packs.dataset.precio || 0);
      var num = tot ? Number(tot.textContent.replace(/[^0-9]/g, '')) * 100 : 0;
      return { total: tot ? tot.textContent.trim() : '', antes: (u > 1 && base * u > num) ? pesos(base * u) : '' };
    }
    var actual = document.querySelector('.cod-precio__actual');
    return { total: actual ? actual.textContent.trim() : '', antes: '' };
  }
  function precioEnBoton(el) {
    var s = el.querySelector('span');
    if (s && !s.classList.contains('ne-cta-texto')) s.classList.add('ne-cta-texto');
    if (s && s.textContent.trim() !== textoCta) s.textContent = textoCta;
    if (!el.querySelector('.ne-cta-linea2')) {
      var p = precioElegido();
      /* span, no <s>: Releasit ordena los span con order: 1 y un <s> se iba al principio */
      var l2 = document.createElement('span'); l2.className = 'ne-cta-linea2';
      var pr = document.createElement('span'); pr.className = 'ne-cta-precio'; pr.setAttribute('data-cod-precio-cta', ''); pr.textContent = p.total;
      var an = document.createElement('span'); an.className = 'ne-cta-antes'; an.textContent = p.antes;
      l2.appendChild(pr); l2.appendChild(an);
      if (s && s.nextSibling) el.insertBefore(l2, s.nextSibling); else el.appendChild(l2);
    }
  }
  if (etiqueta) {
    /* Encabezados fijos apilados: el logo se pega justo debajo del cintillo de arriba, mida lo que mida en cada ficha
       (Ritual: solo la cuenta regresiva; las demás: marquesina + cuenta regresiva). ResizeObserver no fuerza layout. */
    var cintillo = document.querySelector('#MainContent > .shopify-section.cod-anuncios-seccion:first-child');
    if (cintillo && 'ResizeObserver' in window) {
      new ResizeObserver(function (e) {
        var caja = e[0].borderBoxSize && e[0].borderBoxSize[0];
        var alto = caja ? caja.blockSize : e[0].contentRect.height;
        document.body.style.setProperty('--ne-alto-anuncios', Math.round(alto) + 'px');
      }).observe(cintillo);
    }
    document.addEventListener('cod:pack', function () {
      var p = precioElegido();
      document.querySelectorAll('.ne-cta-antes').forEach(function (n) { n.textContent = p.antes; });
    });
  }
  (function () {
    var m = fondo.match(/^#([0-9a-f]{6})$/i);
    if (!m) return;
    var n = parseInt(m[1], 16), r = (n >> 16) / 255, g = ((n >> 8) & 255) / 255, bl = (n & 255) / 255;
    var max = Math.max(r, g, bl), min = Math.min(r, g, bl), d = max - min, h = 0;
    if (d) h = max === r ? 60 * (((g - bl) / d) % 6) : max === g ? 60 * ((bl - r) / d + 2) : 60 * ((r - g) / d + 4);
    h = (h + 360) % 360;
    var rojo = 355;   /* tono HSL de #e11d2e; la máscara (#d92647) queda a 6°, la IPL (#c0456c) a 14° */
    if (Math.min(Math.abs(h - rojo), 360 - Math.abs(h - rojo)) < 10) document.documentElement.style.setProperty('--cod-oferta', '#1f1a1a');
  })();

  function pintar(el, conTexto) {
    if (esperado === null || el.style.getPropertyValue('background-color') !== esperado) {
      el.style.setProperty('background-color', fondo, 'important');
      el.style.setProperty('background-image', degradado, 'important');
      el.style.setProperty('color', color, 'important');
      if (radio) el.style.setProperty('border-radius', radio, 'important');
      el.style.setProperty('box-shadow', sombra, 'important');
      esperado = el.style.getPropertyValue('background-color');
    }
    if (quieto && el.classList.contains('_rsi-buy-now-button-shaker')) el.classList.remove('_rsi-buy-now-button-shaker');
    if (conTexto && etiqueta && el.closest('.cod-ancla-compra')) {
      precioEnBoton(el);
    } else if (conTexto && texto) {
      var s = el.querySelector('span');
      if (s && s.textContent.trim() !== texto) s.textContent = texto;
    }
    if (conTexto) {
      var icono = el.querySelector('._rsi-button-icon-left');
      if (icono && icono.style.display !== 'none') icono.style.setProperty('display', 'none', 'important');
      if (!etiqueta && !el.querySelector('.cod-rsi-flecha')) {
        var flecha = document.querySelector('.cod-boton .cod-boton__flecha');
        if (flecha) {
          var copia = flecha.cloneNode(true);
          copia.classList.add('cod-rsi-flecha');
          el.appendChild(copia);
        }
      }
      /* Se compara con el valor que se va a poner: si no, cada ronda cambia el style y el MutationObserver no para */
      var espacio = etiqueta ? 'normal' : 'nowrap';
      if (el.style.getPropertyValue('white-space') !== espacio) {
        el.style.setProperty('white-space', espacio, 'important');
        el.style.setProperty('font-size', etiqueta ? 'clamp(17px, 5vw, 19.5px)' : 'clamp(15px, 4.6vw, 18px)', 'important');
        el.style.setProperty('gap', etiqueta ? '3px' : '10px', 'important');
      }
    }
  }

  function revisar() {
    document.querySelectorAll('._rsi-buy-now-button-product, #_rsi-buy-now-button-floating ._rsi-buy-now-button').forEach(function (el) { pintar(el, true); });
    // «No, gracias» de los upsells y del downsell también trae _rsi-modal-submit-button: se deja con el estilo secundario
    // de Releasit (blanco con borde). Pintado con la paleta quedaban dos botones verdes iguales (2026-10-07).
    document.querySelectorAll('#_rsi-cod-form-modal ._rsi-modal-submit-button:not(._rsi-modal-submit-button-upsell-no-thanks)').forEach(function (el) { pintar(el, false); });
  }

  revisar();
  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
})();

/* El popup de Releasit abre siempre con la oferta de la cantidad elegida en la página. Al reabrirlo, Releasit recordaba
   la oferta anterior (abrir con 2 kits, cerrar, elegir 1 y reabrir mostraba 2 kits): bloqueante X1 de la auditoría. */
(function () {
  var sincronizado = false;
  function cantidadPagina() {
    // En Dawn 16 el input de cantidad vive FUERA del <form> (atributo form="…"): se busca en la zona del producto
    var q = document.querySelector('product-info[id^="MainProduct-"] input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function nota(m) {
    var texto = document.body.getAttribute('data-cod-nota-popup');
    var ofertas = m.querySelector('._rsi-quantity-offers-offer-container');
    if (!texto || !ofertas || m.querySelector('.cod-rsi-nota')) return;
    var p = document.createElement('p');
    p.className = 'cod-rsi-nota';
    p.textContent = texto;
    var ultima = m.querySelectorAll('._rsi-quantity-offers-offer-container');
    ultima = ultima[ultima.length - 1];
    ultima.parentNode.insertBefore(p, ultima.nextSibling);
  }
  // Cada selector de tono del popup arranca en el tono elegido en la página (con 2 kits en Castaño oscuro, Releasit
  // ponía el 2.º en Negro). Cada selector guarda el tono de la página con el que se alineó: si la persona cambia un
  // tono DENTRO del popup se respeta, pero si cerró, eligió otro tono en la página y volvió a abrir, se realinea
  // (QA 2026-10-19, M1: el popup se quedaba en «Castaño oscuro» ×3 aunque la página decía «Castaño claro»).
  // Releasit, al cambiar de oferta, vuelve a poner el tono que la persona tenía en la apertura anterior: por eso no
  // basta con alinear una vez. Se realinea mientras la persona no haya cambiado ese selector ella misma (change de
  // verdad, isTrusted) en esta apertura.
  function alinearTonos(m) {
    var idInput = document.querySelector('form[action$="/cart/add"] input[name="id"]');
    var vid = idInput && idInput.value;
    if (!vid) return;
    m.querySelectorAll('._rsi-quantity-offers-variants select').forEach(function (s) {
      // si el select aún no trae sus opciones, se reintenta en la próxima mutación
      if (!s.options.length) return;
      if (!s.hasAttribute('data-cod-escucha')) {
        s.setAttribute('data-cod-escucha', '1');
        s.addEventListener('change', function (e) {
          if (e.isTrusted) s.setAttribute('data-cod-usuario', '1');
        });
      }
      if (s.getAttribute('data-cod-usuario') === '1') return;
      s.setAttribute('data-cod-tono', vid);
      if (s.value !== vid && s.querySelector('option[value="' + vid + '"]')) {
        s.value = vid;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  function sincronizar() {
    var m = document.querySelector('#_rsi-cod-form-modal._rsi-cod-form-modal-open');
    if (!m) { sincronizado = false; return; }
    // apertura nueva: lo que la persona tocó en la apertura anterior ya no cuenta
    if (!sincronizado) m.querySelectorAll('select[data-cod-usuario]').forEach(function (s) { s.removeAttribute('data-cod-usuario'); });
    nota(m);
    alinearTonos(m);
    if (sincronizado) return;
    var ofertas = m.querySelectorAll('._rsi-quantity-offers-offer-container');
    if (!ofertas.length) return;
    sincronizado = true;
    var n = cantidadPagina();
    for (var i = 0; i < ofertas.length; i++) {
      var titulo = ofertas[i].querySelector('._rsi-quantity-offers-title') || ofertas[i];
      var k = parseInt(((titulo.textContent || '').match(/\d+/) || ['0'])[0], 10);
      if (k === n) {
        // Releasit escucha el clic en el elemento interno, no en el contenedor
        if (!ofertas[i].classList.contains('_rsi-quantity-offers-selected')) (ofertas[i].querySelector('._rsi-quantity-offers-offer') || ofertas[i]).click();
        return;
      }
    }
  }
  new MutationObserver(sincronizar).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* Carrusel de Reseñas en Buy Box (Saybeam / Jos Poulakis CRO) */
(function () {
  'use strict';
  function initBuyboxSliders() {
    var sliders = document.querySelectorAll('[data-cod-buybox-slider]');
    for (var s = 0; s < sliders.length; s++) {
      var slider = sliders[s];
      if (slider._inited) continue;
      slider._inited = true;
      var slides = slider.querySelectorAll('.cod-buybox-slider__slide');
      var dots = slider.querySelectorAll('.cod-buybox-slider__dot');
      var prevBtn = slider.querySelector('[data-cod-slider-prev]');
      var nextBtn = slider.querySelector('[data-cod-slider-next]');
      if (slides.length <= 1) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        continue;
      }
      (function (sl, dts, pB, nB, container) {
        var current = 0;
        var timer = null;
        function goTo(index) {
          current = (index + sl.length) % sl.length;
          for (var i = 0; i < sl.length; i++) {
            if (i === current) {
              sl[i].hidden = false;
              sl[i].classList.add('is-active');
            } else {
              sl[i].hidden = true;
              sl[i].classList.remove('is-active');
            }
          }
          for (var j = 0; j < dts.length; j++) {
            if (j === current) {
              dts[j].classList.add('is-active');
            } else {
              dts[j].classList.remove('is-active');
            }
          }
        }
        function startTimer() {
          stopTimer();
          timer = setInterval(function () {
            goTo(current + 1);
          }, 5000);
        }
        function stopTimer() {
          if (timer) clearInterval(timer);
        }
        if (pB) {
          pB.addEventListener('click', function (e) {
            e.preventDefault();
            goTo(current - 1);
            startTimer();
          });
        }
        if (nB) {
          nB.addEventListener('click', function (e) {
            e.preventDefault();
            goTo(current + 1);
            startTimer();
          });
        }
        for (var k = 0; k < dts.length; k++) {
          (function (idx) {
            dts[idx].addEventListener('click', function (e) {
              e.preventDefault();
              goTo(idx);
              startTimer();
            });
          })(k);
        }
        container.addEventListener('mouseenter', stopTimer);
        container.addEventListener('mouseleave', startTimer);
        container.addEventListener('touchstart', stopTimer, { passive: true });
        container.addEventListener('touchend', startTimer, { passive: true });
        container.addEventListener('touchcancel', startTimer, { passive: true });
        startTimer();
      })(slides, dots, prevBtn, nextBtn, slider);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyboxSliders);
  } else {
    initBuyboxSliders();
  }

  // Carrusel suave automático para sección de testimonios en móvil
  function initTestimoniosCarrusel() {
    var listas = document.querySelectorAll('.cod-testimonios__lista--carrusel');
    for (var l = 0; l < listas.length; l++) {
      var lista = listas[l];
      if (lista._carruselInited) continue;
      lista._carruselInited = true;
      (function (el) {
        var timer = null;
        var isTouching = false;
        function step() {
          if (isTouching) return;
          var items = el.querySelectorAll('.cod-testimonios__item');
          if (!items || items.length <= 1) return;
          var stepWidth = items[0].offsetWidth + 12;
          var maxScroll = el.scrollWidth - el.clientWidth;
          if (el.scrollLeft + stepWidth >= maxScroll - 8) {
            el.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            el.scrollBy({ left: stepWidth, behavior: 'smooth' });
          }
        }
        function start() {
          stop();
          timer = setInterval(step, 5000);
        }
        function stop() {
          if (timer) clearInterval(timer);
        }
        el.addEventListener('touchstart', function () { isTouching = true; stop(); }, { passive: true });
        el.addEventListener('touchend', function () { isTouching = false; start(); }, { passive: true });
        el.addEventListener('touchcancel', function () { isTouching = false; start(); }, { passive: true });
        el.addEventListener('mouseenter', stop);
        el.addEventListener('mouseleave', start);

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                start();
              } else {
                stop();
              }
            });
          }, { threshold: 0.25 });
          observer.observe(el);
        } else {
          start();
        }
      })(lista);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimoniosCarrusel);
  } else {
    initTestimoniosCarrusel();
  }

  // Puntos de la galería en móvil (sin miniaturas): siguen el slideChanged del slider de Dawn
  function initPuntosGaleria() {
    var grupos = document.querySelectorAll('[data-cod-puntos]');
    Array.prototype.forEach.call(grupos, function (p) {
      var slider = p.closest('slider-component');
      if (!slider) return;
      var puntos = p.children;
      slider.addEventListener('slideChanged', function (e) {
        var i = e.detail && e.detail.currentPage ? e.detail.currentPage - 1 : 0;
        for (var k = 0; k < puntos.length; k++) puntos[k].classList.toggle('is-activo', k === i);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPuntosGaleria);
  } else {
    initPuntosGaleria();
  }
})();

/* «Leer más» de los testimonios: se muestra solo cuando el texto está recortado de verdad. Se mide cada testimonio
   cuando entra en pantalla (medirlos todos al cargar forzaba la maquetación de secciones ocultas y subía el TBT). */
(function () {
  'use strict';
  function revisarUno(q) {
    var p = q.querySelector('p');
    var b = q.nextElementSibling;
    if (!p || !b || !b.classList.contains('cod-recorte__mas') || q.classList.contains('is-abierto')) return;
    b.hidden = !(p.scrollHeight > p.clientHeight + 2);
  }
  function iniciar() {
    var qs = document.querySelectorAll('[data-cod-recorte]');
    if (!qs.length) return;
    if (!('IntersectionObserver' in window)) { qs.forEach(revisarUno); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { revisarUno(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '200px 0px' });
    qs.forEach(function (q) { io.observe(q); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* WhatsApp dentro de la barra fija (auditoría 2026-10-19, O1): una sola pieza fija abajo. Mientras la barra se ve,
   el flotante se esconde (CSS) y este botón abre el mismo panel de temas del flotante. */
(function () {
  'use strict';
  function montar() {
    var wa = document.querySelector('cod-whatsapp');
    var barra = document.querySelector('.cod-barra-fija');
    if (!wa || !barra || barra.querySelector('.cod-barra-fija__wa')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cod-barra-fija__wa';
    b.setAttribute('aria-label', 'Escríbenos por WhatsApp');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.5 15l-1.4 5 5.1-1.3A9.9 9.9 0 1 0 12.04 2zm0 18.1a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-3-.2-.3a8.2 8.2 0 1 1 6.9 3.9zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3a.4.4 0 0 0 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.6a2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>';
    b.addEventListener('click', function (e) {
      // sin propagar: el flotante cierra su panel con cualquier clic fuera de él
      e.stopPropagation();
      // abre el panel de temas del flotante (mismo saludo y número); si no hay panel, abre WhatsApp directo
      if (typeof wa.alternar === 'function') {
        wa.style.display = 'grid';
        wa.classList.remove('is-oculto');
        wa.alternar(true);
        var cerrar = function () { if (!wa.classList.contains('is-abierto')) { wa.style.display = ''; document.removeEventListener('click', cerrar, true); } };
        setTimeout(function () { document.addEventListener('click', cerrar, true); }, 0);
      } else if (wa.dataset.numero) {
        window.open('https://wa.me/' + wa.dataset.numero, '_blank', 'noopener');
      }
    });
    barra.insertBefore(b, barra.firstChild);
  }
  // la barra no se ve al cargar: se monta cuando el hilo principal está libre, fuera del arranque de la página
  function cuandoLibre() { if ('requestIdleCallback' in window) requestIdleCallback(montar, { timeout: 2500 }); else setTimeout(montar, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cuandoLibre);
  else cuandoLibre();
})();
